import { ContactFormData } from "@molecules/contact-form/types";
import { ContactTemplate } from "@templates/contact";
import { GetServerSideProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useCallback } from "react";

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "en", [
        "common",
        "forms",
        "contact",
      ])),
    },
  };
};

export default function Contact() {
  const { t } = useTranslation("contact");

  const handleSubmit = useCallback(async (form: ContactFormData) => {
    const response = await fetch("/api/contact/send", {
      method: "post",
      body: JSON.stringify(form),
      headers: {
        "content-type": "application/json",
      },
    });

    return response.ok;
  }, []);

  return (
    <>
      <Head>
        <title>{t("title")} - FeelingHome</title>
      </Head>
      <ContactTemplate onSubmit={handleSubmit} />
    </>
  );
}
